import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const usePersonAssignmentsList = () => {
    const dispatch = useDispatch();
    const [refetchRemoteData, setRefetchRemoteData] = useState(0);
    const [refetchAssignedItems, setRefetchAssignedItems] = useState(0);

    // Bust backend cache then trigger refetch (mirrors the manual refresh button behavior)
    const handleClearCacheAndRefetch = useCallback(async () => {
        await dispatch(getAssign({ clear_cache: true, pagination: { page: 1, pageSize: 1 } }));
        setRefetchRemoteData(prev => prev + 1);
    }, [dispatch]);

    useEffect(() => {
        // something
    }, [dispatch]);

    const handleDataChange = useCallback(() => {
        setRefetchRemoteData(prev => prev + 1);
        setRefetchAssignedItems(prev => prev + 1);
    }, []);


    return {
        refetchRemoteData,
        refetchAssignedItems,
        handleClearCacheAndRefetch,
        handleDataChange
    };
};

export default usePersonAssignmentsList;
